import { AssetStoryblok, fetchStoryblokData } from "@wojo/storyblok";
import { getStoryblokParams } from "client/hooks";

type InfoCardSlug = "no-upcoming-trips" | "push-to-app-profile";

type InfoCardConfig = {
    lightModeImage: AssetStoryblok;
    darkModeImage: AssetStoryblok;
    title: string;
    description: string;
    primaryActionText: string;
    secondaryActionText: string;
};

export const getAccountInfoCard = async (
    slug: InfoCardSlug,
): Promise<InfoCardConfig | null> => {
    const { fullSlug, sbParams } = getStoryblokParams(
        `configurations/web-account-config/info-cards/${slug}`,
    );

    const { data } = await fetchStoryblokData(fullSlug, sbParams);
    const storyContent = data?.story?.content;

    if (storyContent?.component !== "wojo-web-account-info-card") {
        return null;
    }

    return storyContent;
};
